// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__PVGdw","horizontal":"Divider_horizontal__NJhKG"};